module.exports = __webpack_public_path__ + "static/img/05.c4f6488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/05.png
// module id = uUfW
// module chunks = 1